// Legacy redirect: /signals/:id → /inbox?signal=:id (DEV-16229).
// Per the ticket the canonical detail surface is the Inbox drawer; deep
// links to the old URL still land on the same content.
import { Navigate, createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/signals/$id')({ component: SignalRedirect });

function SignalRedirect() {
  const { id } = useParams({ from: '/signals/$id' });
  return <Navigate to="/inbox" search={{ signal: id }} replace={true} />;
}
